import styled from '@emotion/styled'
import { getFormValues, InjectedFormProps, reduxForm } from 'redux-form'
import {
  DatePickerField,
  InputField,
  SelectField,
  UploadfileField,
} from '../../components/common/fields'
import Card from '../../components/common/Card'
import Text from '../../components/common/Text'
import { mobile, mobileVerySmall } from '../../utils/responsive-helper'
import moment from 'moment'
import FooterContent from '../../components/FooterContent'
import Button from '../../components/common/Button'
import { EClaimFormParams, EClaimHistoryItem, EClaimItem } from '../../services/e-claim/e-claim-types'
import { ComponentType, useEffect, useMemo, useState } from 'react'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import * as paths from '../../constant/path'
import Input, { InputLabel } from '../../components/common/Input'
import color from '../../constant/colors'
import { useGetUser, useGetUserCoin } from '../../services/user/user-query'
import {
  useCreateUserClaim,
  useGetRelativeOption,
  useUploadFile,
  // useUploadReceiptImage,
} from '../../services/e-claim/e-claim-query'
import { UserClaimDocumentList, FileType } from '../../services/e-claim/e-claim-types'
import { Moment } from 'moment'
import Modal from '../../components/common/Modal'
import { useVisibility } from '../../utils/custom-hook'
import { convertBase64ToFile, getToken, numberWithCommas, useRelativeTypeName } from '../../utils/helper'
import { Divider, Tooltip } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import { CreateRelative } from '../Relative/component'
import { useTranslation } from 'react-i18next'
import OutlineButton from '../../components/common/OutlineButton'
import Image from '../../components/common/Image'
import config from '../../config'
import { setInsuranceInfo, InsuranceInfoWithConcentDate, InsuranceInfoWithoutConcentDate } from '../../redux-store/insurance-reducer'

const ClaimFormContainer = styled(Card)`
  padding: 16px;
  .layout-upload {
    ${mobile} {
      width: 100%;
    }
    ${mobileVerySmall} {
      width: 100%;
    }
  }
  ${mobile} {
    padding: 16px;
  }
  ${mobileVerySmall} {
    padding: 16px;
  }
`

const Spacer = styled.div`
  width: 20px;
  height: 20px;

  ${mobile} {
    display: none;
  }
`

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  column-gap: 16px;

  ${mobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`

const FileUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;

  ${mobile} {
    flex-direction: column;
  }
`

const CustomEditableFooter = styled(FooterContent)`
  height: 80;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 18px;
  padding-bottom: 18px;

  ${mobile} {
    justify-content: center;
  }
`

const CustomUnEditableFooter = styled(FooterContent)`
  height: 80;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 18px;
  padding-bottom: 18px;
  column-gap: 16px;
  
  ${mobile} {
    flex-direction: column;
    justify-content: center;
  }
`

const SumPointContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-start;

  ${mobile} {
    margin-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
  }
`

const BackToEditButton = styled(Button)`
  width: 267px;
`
const SubmitButton = styled(Button)`
  width: 267px;
`
const TextModal = styled(Text)`
  text-align: center;
`

const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  /* border: 1px solid; */
  margin-bottom: 8px;
  padding-bottom: 0;

  ${mobile} {
    width: 100%;
  }
`

const RelativeField = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  column-gap: 8px;
`

const CreateRelativeButton = styled(Button)`
  width: fit-content;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const INSURANCE_FORM_NAME = 'INSURANCE_FORM'
type EClaimItemType = EClaimItem & EClaimHistoryItem
type EClaimParam = {
  insuranceItem?: Partial<EClaimItemType>
  editable?: boolean
  insuranceFormValue?: InsuranceInfoWithConcentDate & InsuranceInfoWithoutConcentDate
  isPreview?: boolean
  allpayStatus?: boolean
  isHistory?: boolean
  insuranceId?: number
  isCreateNew?: 'true' | 'false'
}
const required = (value: string) => (value ? undefined : 'error.required')
const requiredDate = (value: Moment) => {
  const x = moment(value).isValid() ? undefined : 'error.required'
  return x
}
const InsuranceForm: ComponentType<
  EClaimParam & InjectedFormProps<EClaimFormParams, EClaimParam, string>
> = (props) => {
  const dispatch = useDispatch()
  const {
    handleSubmit,
    invalid,
    insuranceItem,
    editable = true,
    insuranceFormValue,
    isPreview = false,
    allpayStatus,
    isHistory = false,
    insuranceId,
    initialize,
    isCreateNew
  } = props

  const formValuesSelector = getFormValues(INSURANCE_FORM_NAME)
  const formValues = useSelector<any, EClaimFormParams>(
    (state) => formValuesSelector(state) as EClaimFormParams,
  )
  const { t } = useTranslation()
  const [visible, modalAction] = useVisibility()
  const [visibleError, modalActionError] = useVisibility()
  const [errorMessage, setErrorMessage] = useState('')
  const [isClaimCheck, setIsClaimCheck] = useState(false)
  const [claimAmountCheck, setClaimAmountCheck] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const { data: user } = useGetUser()
  const { firstName, lastName, userId } = user || {}

  const fullname = `${firstName} ${lastName}`
  const history = useHistory()
  const { data: userCoin = 0 } = useGetUserCoin()
  const { data: relativesOptions, refetch: refetchRelative } = useGetRelativeOption(insuranceId)
  const { mutate: createUserClaim, isLoading: isSubmitting } = useCreateUserClaim()
  const { mutateAsync: uploadFile, isLoading: isUploading } = useUploadFile()
  // const { mutateAsync: uploadReceiptImage, isLoading: isUploadingReceipt, isError: isErrorUplaodReceiptImage } = useUploadReceiptImage()

  useEffect(() => {
    if (isCreateNew) {
      initialize({
        amountReceipt: insuranceFormValue?.amountReceipt ? insuranceFormValue?.amountReceipt : undefined,
        amountClaim: insuranceFormValue?.amountClaim ? insuranceFormValue?.amountClaim : undefined,
        receiptFile: insuranceFormValue?.receiptFile ? insuranceFormValue?.receiptFile : '',
        optionalFileUrl: insuranceFormValue?.optionalFileUrl ? insuranceFormValue?.optionalFileUrl : '',
        relativeTypeId: insuranceFormValue?.relativeTypeId ? insuranceFormValue?.relativeTypeId : '0',
        receiptDate: insuranceFormValue?.receiptDate ? insuranceFormValue?.receiptDate : undefined,
        receiptNo: insuranceFormValue?.receiptNo ? insuranceFormValue?.receiptNo : '',
        // remark: insuranceFormValue?.remark ? insuranceFormValue?.remark : '',
      })
    } else {
      initialize({
        amountReceipt: formValues?.amountReceipt ? formValues?.amountReceipt : undefined,
        amountClaim: formValues?.amountClaim ? formValues?.amountClaim : undefined,
        receiptFile: formValues?.receiptFile ? formValues?.receiptFile : undefined,
        optionalFileUrl: formValues?.optionalFileUrl ? formValues?.optionalFileUrl : undefined,
        relativeTypeId: formValues?.relativeTypeId ? formValues?.relativeTypeId : '0',
        receiptDate: formValues?.receiptDate ? formValues?.receiptDate : undefined,
        receiptNo: formValues?.receiptNo ? formValues?.receiptNo : '',
        // remark: formValues?.remark ? formValues?.remark : '',
      })
    }
  }, [])

  const onSubmit = useCallback(
    (form: EClaimFormParams) => {

      dispatch(
        setInsuranceInfo({
          id: insuranceItem?.id,
          name: form.name,
          amountReceipt: form.amountReceipt,
          amountClaim: claimAmountCheck,
          receiptFile: form.receiptFile,
          optionalFileUrl: form.optionalFileUrl,
          relativeTypeId: form.relativeTypeId,
          receiptDate: form.receiptDate,
          claimName: form.claimName,
          consentDate: insuranceFormValue?.consentDate,
          receiptNo: form.receiptNo || '',
          // remark: form.remark || '',
        }),
      )
      if (editable === true) {
        history.push(paths.insuranceSummary({ routeParam: { insuranceId: insuranceItem?.id || 0 } }))
      }
    },
    [dispatch, insuranceItem?.id, editable, history, claimAmountCheck, insuranceFormValue?.consentDate],
  )

  const getImageUploadUrl = useCallback(async (image, documentTypeId) => {
    try {
      const imageFile = await convertBase64ToFile(image || '')
      const imageFileUrl = await uploadFile({ files: imageFile, documentTypeId })

      return imageFileUrl[0].name
    } catch (error) {
      console.log("error", error)

      return ''
    }
  }, [uploadFile])

  const onSubmitApplication = useCallback(async () => {
    setIsLoading(true)
    const documentTypeIdForReceipt = insuranceItem?.claimDocumentTypes?.find((item) => item.documentType.name === FileType.ReceiptFile)?.documentType.id
    const documentTypeIdForOptionalFile = insuranceItem?.claimDocumentTypes?.find((item) => item.documentType.name === FileType.OptionalFileUrl)?.documentType.id

    let receiptImageURL = undefined
    let optionalFileUrl = undefined

    if (insuranceFormValue?.receiptFile && insuranceFormValue?.receiptFile.split('/')[0].split(':')[0] === 'data') {
      //uploadfile
      receiptImageURL = await getImageUploadUrl(insuranceFormValue?.receiptFile || '', documentTypeIdForReceipt)
    } else {
      receiptImageURL = insuranceFormValue?.receiptFile
    }

    if (insuranceFormValue?.optionalFileUrl && insuranceFormValue?.optionalFileUrl.split('/')[0].split(':')[0] === 'data') {
      //uploadfile
      optionalFileUrl = await getImageUploadUrl(insuranceFormValue?.optionalFileUrl || '', documentTypeIdForOptionalFile)
    } else {
      optionalFileUrl = insuranceFormValue?.optionalFileUrl
    }

    const userClaimDocumentList: UserClaimDocumentList[] = []
    if (receiptImageURL) {
      userClaimDocumentList.push({
        documentTypeId: documentTypeIdForReceipt || 0,
        documentPath: receiptImageURL,
      })
    }
    if (optionalFileUrl) {
      userClaimDocumentList.push({
        documentTypeId: documentTypeIdForOptionalFile || 0,
        documentPath: optionalFileUrl,
      })
    }
    createUserClaim(
      {
        claimId: insuranceItem?.id || 0,
        receiptAmount: insuranceFormValue?.amountReceipt!,
        relativeId: insuranceFormValue?.relativeTypeId === '0' ? 0 : Number(insuranceFormValue?.relativeTypeId),
        receiptDate: dayjs(insuranceFormValue?.receiptDate).toISOString() || '',
        consentDate: insuranceFormValue?.consentDate || null,
        consentBy: userId || 0,
        userClaimDocumentList: userClaimDocumentList,
        receiptNo: insuranceFormValue?.receiptNo || '',
        // remark: insuranceFormValue?.remark || '',
      },
      {
        onSuccess: (props) => {
          setIsLoading(false)
          history.push(
            paths.insuranceCompleted({
              routeParam: { insuranceId: insuranceItem?.id || 0 },
              queryParam: {
                userClaimId: props?.id || 0,
              },
            }),
          )
        },
        onError: (error) => {
          setIsLoading(false)
          setErrorMessage(error.message)
          modalActionError.show()
        },
      },
    )
  }, [
    getImageUploadUrl,
    createUserClaim,
    insuranceItem?.id,
    insuranceItem?.claimDocumentTypes,
    insuranceFormValue?.amountReceipt,
    insuranceFormValue?.relativeTypeId,
    insuranceFormValue?.receiptDate,
    insuranceFormValue?.receiptFile,
    insuranceFormValue?.optionalFileUrl,
    insuranceFormValue?.consentDate,
    insuranceFormValue?.receiptNo,
    // insuranceFormValue?.remark,
    history,
    modalActionError,
    userId
  ])

  const onBackToEdit = useCallback(() => {
    history.push(paths.insuranceDetail({ routeParam: { insuranceId: insuranceItem?.id || 0 } }))
  }, [insuranceItem?.id, history])

  const onCheckCoin = useCallback(() => {
    if (!formValues?.amountReceipt) return

    fetch(`${config.apiHost}/app/userClaim/claimableAmount?requestAmount=${formValues?.amountReceipt}&claimId=${insuranceId}`, {
      method: 'GET',
      headers: {
        'X-Auth-Token': `${getToken()}`
      }
    })
      .then((res) => res.json())
      .then((res) => {
        setClaimAmountCheck(res.claimableAmount)
        setIsClaimCheck(true)
        if (res.claimableAmount === 0 || formValues?.amountReceipt > res.claimableAmount) {
          modalAction.show()
        }
      })
  }, [modalAction, formValues, insuranceId])

  const validateImage = useCallback((name: 'receiptFile' | 'optionalFileUrl', isRequired) => {
    if (isPreview === false && (!formValues[name]) && isRequired) {
      return [required]
    } else {
      return undefined
    }
  }, [formValues, isPreview])

  const validateClaimAmount = useCallback(
    (value) => {
      if (insuranceItem?.claimPrice && value > insuranceItem?.claimPrice) {
        return 'eClaim.claimPriceError'
      }
    },
    [insuranceItem?.claimPrice],
  )

  const isEnoughCoin = useCallback(
    (value) => {
      if (value > userCoin) {
        return 'eClaim.coinError'
      }
    },
    [userCoin])

  const isNotZero = useCallback(
    (value) => {
      if (value === '0') {
        return 'error.required'
      }
    }
    , [])

  const nameRelative = useCallback(
    (relativeId: number | string) => {
      const data = relativesOptions?.map((relativesOption) => {
        const { value, label } = relativesOption
        if (relativeId.toString() === value) {
          return label
        }
      })
      return data?.length === 0 ? 'ตัวเอง' : data
    },

    [relativesOptions],
  )

  const fullNameSummary = useMemo(() => {
    if (!insuranceFormValue?.relativeTypeId) return fullname

    return insuranceFormValue?.relativeTypeId === '0' ? fullname : nameRelative(insuranceFormValue?.relativeTypeId)
  }, [insuranceFormValue?.relativeTypeId, fullname, nameRelative])

  const disbleField = allpayStatus ? true : false

  const disabledSubmit = useMemo(() => {
    if (insuranceItem?.useCoin) {
      return invalid || !isClaimCheck
    } else {
      return invalid
    }
  }, [invalid, isClaimCheck, insuranceItem?.useCoin])

  if (editable && !formValues) return null

  return (
    <>
      <Modal
        visible={visibleError}
        onCancel={() => {
          modalActionError.hide()
        }}
        onCancelText="ตกลง"
      >
        <div style={{ margin: '30px' }}>
          <TextModal size={24} type="Bold">
            {errorMessage}
          </TextModal>
          <TextModal>กรุณาตรวจสอบอีกครั้ง</TextModal>
        </div>
      </Modal>
      <Modal
        visible={visible}
        onCancel={() => {
          modalAction.hide()
        }}
        onCancelText="ตกลง"
      >
        <div style={{ margin: '30px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', rowGap: 8 }}>
          <Image imageName='iconAlertPrivacy' width={72} />
          <TextModal>วงเงินของคุณเหลือไม่พอเบิก</TextModal>
          <TextModal>วงเงินที่เหลือของคุณสามารถเบิกได้ {numberWithCommas(claimAmountCheck)} coins</TextModal>
        </div>
      </Modal>
      <ClaimFormContainer>
        <Text size={24} type="Bold">
          {editable ? 'กรอกรายละเอียดการเบิกสวัสดิการ' : 'ตรวจสอบรายละเอียด '}
        </Text>
        <InputContainer>
          {editable && (
            <FlexCol>
              <InputLabel size={18}>ชื่อ - นามสกุล ผู้ขอเบิก</InputLabel>
              <Text type="Bold" size={16}>{fullname}</Text>
            </FlexCol>
          )}
          {editable && (
            <FlexCol>
              <InputLabel size={18}>
                {t('eClaim.detail.form.claimFor')}{' '}
              </InputLabel>
              <RelativeField>
                <SelectField
                  name="relativeTypeId"
                  placeholder={t('eClaim.detail.form.claimFor')}
                  validate={[required]}
                  options={relativesOptions || []}
                  disabled={disbleField}
                  style={{ width: '100%' }}
                />
                {/* <CreateRelativeButton onClick={setVisibleCreate.show}>{t('family.addTitle')}</CreateRelativeButton> */}
              </RelativeField>
            </FlexCol>
          )}
          {isHistory && (
            <>
              <FlexCol>
                <InputLabel size={18}>{t('eClaim.detail.form.claimFor')}</InputLabel>
                <Text size={16} type='Bold'>{insuranceItem?.relativeId ? nameRelative(insuranceItem?.relativeId) : fullname}</Text>
              </FlexCol>
            </>
          )}
          {isPreview && (
            <FlexCol>
              <InputLabel size={18}>{t('eClaim.detail.form.claimFor')}</InputLabel>
              <Text size={16} type='Bold'>{fullNameSummary}</Text>
            </FlexCol>
          )}
        </InputContainer>
        <InputContainer>
          <FlexCol>
            {editable && (
              <InputField
                name="receiptNo"
                label={t('eClaim.detail.form.receiptNo')}
                placeholder={t('eClaim.detail.form.inputReceiptNo')}
                validate={[required]}
                disabled={disbleField}
                labelSize={18}
              />
            )}
            {isPreview && (
              <>
                <InputLabel size={18}>{t('eClaim.detail.form.receiptNo')}</InputLabel>
                <Text type="Bold">{insuranceFormValue?.receiptNo}</Text>
              </>
            )}
            {isHistory && (
              <>
                <InputLabel size={18}>{t('eClaim.detail.form.receiptNo')}</InputLabel>
                <Text type="Bold">{insuranceItem?.receiptNo}</Text>
              </>
            )}
          </FlexCol>
          <FlexCol>
            {editable && (
              <DatePickerField
                name="receiptDate"
                label="วันที่ในใบเสร็จ"
                validate={[required, requiredDate]}
                disabled={disbleField}
                labelSize={18}
                maxDate={dayjs().endOf('day')}
                minDate={dayjs('07/01/2023')}

              />
            )}
            {isPreview && (
              <>
                <InputLabel size={18}>วันที่ในใบเสร็จ</InputLabel>
                <Text type="Bold">{dayjs(insuranceFormValue?.receiptDate).format('DD/MM/YYYY')}</Text>
              </>
            )}
            {isHistory && (
              <>
                <InputLabel size={18}>วันที่ในใบเสร็จ</InputLabel>
                <Text type="Bold">{dayjs(insuranceItem?.slipDate).format('DD/MM/YYYY')}</Text>
              </>
            )}
          </FlexCol>
        </InputContainer>
        <InputContainer>
          <FlexCol>
            {editable && (
              <InputField
                name="amountReceipt"
                label={t('eClaim.detail.form.amountReceipt')}
                placeholder={t('eClaim.detail.form.inputAmount')}
                validate={[required, validateClaimAmount, isNotZero]}
                inputType="number"
                disabled={disbleField}
                labelSize={18}
              />
            )}
            {isPreview && (
              <>
                <InputLabel size={18}>{t('eClaim.detail.form.amountReceipt')}</InputLabel>
                <Text type="Bold" size={16}>
                  {insuranceFormValue?.amountReceipt ? numberWithCommas(Number(insuranceFormValue?.amountReceipt)) : 0}
                </Text>
              </>
            )}
            {isHistory && (
              <>
                <InputLabel size={18}>{t('eClaim.detail.form.amountReceipt')}</InputLabel>
                <Text type="Bold" size={16}>
                  {insuranceItem?.userClaimAmount ? numberWithCommas(Number(insuranceItem?.userClaimAmount)) : 0}
                </Text>
              </>
            )}
          </FlexCol>
          {insuranceItem?.useCoin && (
            <>
              {editable && (
                <FlexCol style={{ marginBottom: 0 }}>
                  <InputLabel size={18}>{' '}</InputLabel>
                  <OutlineButton onClick={onCheckCoin}>ตรวจสอบสิทธิ</OutlineButton>
                </FlexCol>
              )}
              <FlexCol>
                {isClaimCheck && (
                  <>
                    <InputLabel size={18}>{t('eClaim.detail.form.claimAmount')}</InputLabel>
                    <Text type="Bold" size={16}>{numberWithCommas(claimAmountCheck)}</Text>
                  </>
                )}
                {isPreview && (
                  <>
                    <InputLabel size={18}>{t('eClaim.detail.form.claimAmount')}</InputLabel>
                    <Text type="Bold" size={16}>
                      {insuranceFormValue?.amountClaim ? numberWithCommas(Number(insuranceFormValue?.amountClaim)) : 0}
                    </Text>
                  </>
                )}
                {isHistory && (
                  <>
                    <InputLabel size={18}>{t('eClaim.detail.form.claimAmount')}</InputLabel>
                    <Text type="Bold" size={16}>
                      {insuranceItem?.userClaimAmountApprove ? numberWithCommas(Number(insuranceItem?.userClaimAmountApprove)) : 0}
                    </Text>
                  </>
                )}
              </FlexCol>
            </>
          )}
          {/* <FlexCol style={{ marginBottom: 0 }}>
            <InputLabel size={18}>{' '}</InputLabel>
            {editable && (<OutlineButton onClick={onCheckCoin}>ตรวจสอบสิทธิ</OutlineButton>)}
          </FlexCol>
          <FlexCol>
            {isClaimCheck && (
              <>
                <InputLabel size={18}>{t('eClaim.detail.form.claimAmount')}</InputLabel>
                <Text type="Bold" size={16}>{numberWithCommas(claimAmountCheck)}</Text>
              </>
            )}
            {isPreview && (
              <>
                <InputLabel size={18}>{t('eClaim.detail.form.claimAmount')}</InputLabel>
                <Text type="Bold" size={16}>
                  {insuranceFormValue?.amountClaim ? numberWithCommas(Number(insuranceFormValue?.amountClaim)) : 0}
                </Text>
              </>
            )}
            {isHistory && (
              <>
                <InputLabel size={18}>{t('eClaim.detail.form.claimAmount')}</InputLabel>
                <Text type="Bold" size={16}>
                  {insuranceItem?.userClaimAmountApprove ? numberWithCommas(Number(insuranceItem?.userClaimAmountApprove)) : 0}
                </Text>
              </>
            )}
          </FlexCol> */}
        </InputContainer>
        {/* <InputContainer>
          <FlexCol>
            {editable && (
              <InputField
                name="remark"
                label={t('eClaim.detail.form.remark')}
                placeholder={t('eClaim.detail.form.inputRemark')}
                disabled={disbleField}
                labelSize={18}
              />
            )}
            {isPreview && (
              <>
                <InputLabel size={18}>{t('eClaim.detail.form.remark')}</InputLabel>
                <Text type="Bold">{insuranceFormValue?.remark}</Text>
              </>
            )}
            {isHistory && (
              <>
                <InputLabel size={18}>{t('eClaim.detail.form.remark')}</InputLabel>
                <Text type="Bold">{insuranceItem?.remark}</Text>
              </>
            )}
          </FlexCol>
        </InputContainer> */}
        <Text size={24} type="Bold">
          {t('eClaim.detail.form.attachDocuments')}
        </Text>
        <FileUploadContainer>
          {!isHistory && insuranceItem && insuranceItem?.claimDocumentTypes?.map((item, index) => {
            return (
              <UploadfileField
                key={index}
                name={item.documentType.name === FileType.ReceiptFile ? 'receiptFile' : 'optionalFileUrl'}
                icon={'receiptIcon'}
                title={`${index + 1}. ${item.documentType.name}`}
                desc={item.documentType.description || ''}
                // value={item.documentType.name === FileType.ReceiptFile ? insuranceFormValue?.receiptFile : insuranceFormValue?.optionalFileUrl}
                isDelete={isPreview}
                validate={validateImage(item.documentType.name === FileType.ReceiptFile ? 'receiptFile' : 'optionalFileUrl', item.isRequired)}
                maximumFileSize={3}
              // disabled={disbleField}
              />
            )
          })
          }
          {isHistory && insuranceItem && insuranceItem?.documentTypes?.map((item, index) => {
            return (
              <UploadfileField
                key={index}
                name={item.name === FileType.ReceiptFile ? 'receiptFile' : 'optionalFileUrl'}
                icon={'receiptIcon'}
                title={`${index + 1}. ${item.name}`}
                desc={item.description || ''}
                // value={insuranceFormValue?.userClaimDocumentList[index]?.documentPath}
                isDelete={isHistory}
                // validate={validateImage(item.documentType.name === FileType.ReceiptFile ? 'receiptFile' : 'optionalFileUrl', item.isRequired)}
                maximumFileSize={3}
                disabled={true}
              />
            )
          })
          }
        </FileUploadContainer>
        {editable && (
          <ButtonWrapper>
            <SubmitButton onClick={handleSubmit(onSubmit)} disabled={disabledSubmit}>
              {t('eClaim.detail.form.next')}
            </SubmitButton>
          </ButtonWrapper>
        )}
        {isPreview && (
          <ButtonWrapper>
            <SubmitButton onClick={onSubmitApplication} disabled={isSubmitting || isUploading || isLoading}>
              {t('eClaim.detail.form.submit')}
            </SubmitButton>
          </ButtonWrapper>
        )}
      </ClaimFormContainer>
    </>
  )
}

export default reduxForm<EClaimFormParams, EClaimParam, string>({
  form: INSURANCE_FORM_NAME,
})(InsuranceForm)
